{ partitionAndSort, sort } = require('../utils')
_ = require('lodash')

angular.module('workflow.app')

.service 'Utils', ( $window ) ->
  {
    getArrayItemByFieldValue: ( aArray, aField, aValue ) ->
      _.find(aArray, aField, aValue)
      # Newer versions of lodash require a different syntax:
      # _.find(aArray, (o) -> o[aField] == aValue)

    getArrayItemById: ( aArray, aValue ) ->
      @getArrayItemByFieldValue( aArray, 'id', aValue )

    removeItemFromArray: ( aArray, aItem ) ->
      itemIndex = aArray.indexOf( aItem )
      if itemIndex != -1
        aArray.splice( itemIndex, 1 )

    partitionAndSort: ( aArray, partition, sort) ->
      partitionAndSort(aArray, partition, sort)

    # Based on http://stackoverflow.com/a/679937
    isEmptyObject: ( aObj ) ->
      for prop of aObj
        if aObj.hasOwnProperty(prop)
          return false
      true

    sort: (list, key, ascending = true) ->
      sort( list, key, ascending )

    merge: ( dst, src ) ->
      _.merge( dst, src )
  }
